import { Check, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { STATUS_LIST, ContractingUserStatus } from "@/lib/domain-constants";
import { useUpdateContractingStatus } from "@/hooks/mutations/useContractingMutations";

export function StatusActions({
  contractingId,
  status,
  size = "sm",
}: {
  contractingId: number;
  status?: number | null;
  size?: "sm" | "md";
}) {
  const mutation = useUpdateContractingStatus();
  const current = status ?? ContractingUserStatus.SIN_ESTADO;

  function setStatus(value: number) {
    mutation.mutate(
      { contracting_id: contractingId, status: value },
      { onError: () => toast.error("No se pudo actualizar el estado") },
    );
  }

  const currentMeta = STATUS_LIST.find((s) => s.value === current)!;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          onClick={(e) => e.stopPropagation()}
          disabled={mutation.isPending}
          className={cn(
            "inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-semibold transition-colors",
            currentMeta.badge,
            "border-transparent hover:opacity-90",
            size === "md" && "px-3 py-1.5 text-sm",
          )}
        >
          {currentMeta.label}
          <ChevronDown className="h-3 w-3 opacity-70" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        onClick={(e) => e.stopPropagation()}
      >
        {STATUS_LIST.map((s) => (
          <DropdownMenuItem
            key={s.value}
            onClick={() => setStatus(s.value)}
            className="cursor-pointer gap-2"
          >
            <span
              className="h-2 w-2 rounded-full"
              style={{ backgroundColor: s.color }}
            />
            {s.label}
            {s.value === current && (
              <Check className="ml-auto h-3.5 w-3.5 text-primary" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
